var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2993_15556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 11.8333C4.21903 11.8333 4.66675 11.3856 4.66675 10.8333C4.66675 10.2811 4.21903 9.83334 3.66675 9.83334C3.11446 9.83334 2.66675 10.2811 2.66675 10.8333C2.66675 11.3856 3.11446 11.8333 3.66675 11.8333Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2.5H3.33333C2.4496 2.50106 1.60237 2.85259 0.97748 3.47748C0.352588 4.10237 0.00105857 4.9496 0 5.83333L0 11.1667C0.00105857 12.0504 0.352588 12.8976 0.97748 13.5225C1.60237 14.1474 2.4496 14.4989 3.33333 14.5H12.6667C13.5504 14.4989 14.3976 14.1474 15.0225 13.5225C15.6474 12.8976 15.9989 12.0504 16 11.1667V5.83333C15.9989 4.9496 15.6474 4.10237 15.0225 3.47748C14.3976 2.85259 13.5504 2.50106 12.6667 2.5ZM3.33333 3.83333H12.6667C13.1971 3.83333 13.7058 4.04405 14.0809 4.41912C14.4559 4.79419 14.6667 5.3029 14.6667 5.83333H1.33333C1.33333 5.3029 1.54405 4.79419 1.91912 4.41912C2.29419 4.04405 2.8029 3.83333 3.33333 3.83333ZM12.6667 13.1667H3.33333C2.8029 13.1667 2.29419 12.9559 1.91912 12.5809C1.54405 12.2058 1.33333 11.6971 1.33333 11.1667V7.16666H14.6667V11.1667C14.6667 11.6971 14.4559 12.2058 14.0809 12.5809C13.7058 12.9559 13.1971 13.1667 12.6667 13.1667Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2993_15556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.993b71ad1bb1896fe281005f2b58a7b1.svg";
export { ForwardRef as ReactComponent };